import { pStyles } from 'components/reusable-css';
import styled from 'styled-components';
import { deviceBreakpoints, variables } from 'variables';

export const NewBMStep3SC = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  background: ${(props) => props.theme.pageBackgroundColor};
  padding: ${variables.pageContentPadding}px;
  // padding-top: 75px;
  padding-top: 60px;
  border-bottom: 4px solid ${(props) => props.theme.primaryDarkColor};
`;

export const StepDescription = styled.div`
  margin: 30px 0;
  width: 100%;
  display: flex;
  flex-direction: row; 
  flex-wrap-wrap;
  
  @media only screen and (max-width:${deviceBreakpoints.phone}px) {
    display: flex;
    flex-direction: column;    
  }
`;

export const Description = styled.div`
  width: 82%;
  @media only screen and (max-width: ${deviceBreakpoints.phone}px) {
    width: 100%;
  }
`;

export const Paragraph = styled.p`
  font-size: ${(props) => props.theme.default?.p};
  ${(props) => pStyles(props.theme.resolutions)};
`;

export const Image = styled.div`
  width: 18%;
  @media only screen and (max-width: ${deviceBreakpoints.phone}px) {
    width: 100%;
  }
`;

export const AnchorTag = styled.a`
  padding: 0 5px;
  color: black;
  text-decoration: underline;
  &:hover {
    text-decoration: none;
    color: black;
  }
`;
